import moment from 'moment/moment';

export const getDatesConfig = (
    startDate: string | undefined,
    endDate: string | undefined,
) => {
    const prevMinDate = startDate
        ? moment(startDate, 'DD-MM-YYYY')
              .subtract(1, 'year')
              .format('DD-MM-YYYY')
        : '';

    const prevMaxDate = endDate
        ? moment(endDate, 'DD-MM-YYYY').format('DD-MM-YYYY')
        : '';

    const prevYearEndDate = endDate
        ? moment(endDate, 'DD-MM-YYYY')
              .subtract(1, 'year')
              .format('DD-MM-YYYY')
        : '';

    const prevYearStartDate = prevMaxDate
        ? moment(prevMaxDate, 'DD-MM-YYYY')
              .subtract(1, 'year')
              .format('DD-MM-YYYY')
        : '';

    return {
        prevMinDate,
        prevMaxDate,
        prevYearEndDate,
        prevYearStartDate,
    };
};
